import { render, staticRenderFns } from "./QueriesHeader.vue?vue&type=template&id=e4987774&scoped=true&"
import script from "./QueriesHeader.vue?vue&type=script&lang=ts&"
export * from "./QueriesHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QueriesHeader.vue?vue&type=style&index=0&id=e4987774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4987774",
  null
  
)

export default component.exports